import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Template, TemplateListingService } from '../../../core/template-listing.service';
import { ReviewRequestType } from '../../../common/constants';
import { styleVisibility } from '../../../common/visibility-helper';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';

@Component({
  selector: 'app-preview-template',
  templateUrl: './preview-template.component.html',
  styleUrls: ['./preview-template.component.scss'],
  standalone: false,
})
export class PreviewTemplateComponent implements OnInit {
  styleVisibility: (v: boolean) => string = styleVisibility;
  ReviewRequestType = ReviewRequestType;

  loadingTemplate = false;
  html = '';
  selectedTemplateId: string;
  selectedTemplateType: ReviewRequestType;

  @ViewChild('emailIFrame')
  emailIFrame: ElementRef;

  @Output() canTemplateRender: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() set selectedTemplate(template: Template) {
    if (template !== undefined) {
      this.html = '';
      this.selectedTemplateId = template.templateId;
      this.selectedTemplateType = template.templateType;
      this.loadingTemplate = true;

      this.templateListingService.getPreview(template.templateId, template.templateType).subscribe(
        (content) => {
          this.html = content;
          this.loadingTemplate = false;
          this.canTemplateRender.emit(true);
        },
        (err) => {
          this.loadingTemplate = false;
          this.canTemplateRender.emit(false);
          this.templateListingService.loadingPreview = false;
          if (err.status === 400) {
            this.snackbarService.errorSnack(
              this.translateService.instant('SETTINGS.TEMPLATE_SETTINGS.PREVIEW_FAILURE_INVALID_CONTENT'),
            );
          } else {
            this.snackbarService.errorSnack(
              this.translateService.instant('SETTINGS.TEMPLATE_SETTINGS.PREVIEW_FAILURE'),
            );
          }
        },
      );
    }
  }

  constructor(
    private templateListingService: TemplateListingService,
    private translateService: TranslateService,
    private snackbarService: SnackbarService,
  ) {}

  ngOnInit(): void {
    this.templateListingService.fetchDefaultTemplateId();
  }
}
